<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>系统公告配置{{ formData.id > 0 ? '编辑' : '新增' }}</span>
        </div>
        <el-form ref="formData" :rules="rules" :model="formData" label-width="120px">
          <!--          <el-form-item label="时间范围">-->
          <!--            <el-form :inline="true">-->
          <!--              <el-form-item>-->
          <!--                <el-date-picker v-model="formData.stime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" style="width: 200px" placeholder="开始时间" />-->
          <!--              </el-form-item>-->
          <!--              <el-form-item label="-">-->
          <!--                <el-date-picker v-model="formData.etime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" style="width: 200px" placeholder="结束时间" />-->
          <!--              </el-form-item>-->
          <!--            </el-form>-->
          <!--          </el-form-item>-->
          <!--          <el-form-item label="影响版本" prop="version">-->
          <!--            <el-select v-model="formData.version" multiple placeholder="请选择" style="width: 800px">-->
          <!--              <el-option-->
          <!--                v-for="item in versionData"-->
          <!--                :key="item.value"-->
          <!--                :label="item.label"-->
          <!--                :value="item.value"-->
          <!--              />-->
          <!--            </el-select>-->
          <!--          </el-form-item>-->
          <el-form-item label="强制更新" prop="is_force">
            <el-form :inline="true">
              <el-form-item>
                <el-select v-model.number="formData.is_force" placeholder="请选择">
                  <el-option
                    v-for="(item, index) in statusType"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>

              <el-form-item label="粉丝URL" prop="fansUrl">
                <el-input v-model="formData.fansUrl" style="width: 350px;" placeholder="粉丝URL" />
              </el-form-item>
            </el-form>
          </el-form-item>

          <el-form-item label="安卓-更新URL" prop="updateUrl">
            <el-form :inline="true">
              <el-form-item>
                <el-input v-model="formData.updateUrl" style="width: 350px;" placeholder="更新URL" />
              </el-form-item>

              <el-form-item label="安卓-评论URL" prop="commentUrl">
                <el-input v-model="formData.commentUrl" style="width: 350px;" placeholder="评论url" />
              </el-form-item>
            </el-form>

          </el-form-item>

          <el-form-item label="苹果-更新URL" prop="iosUpdateUrl">
            <el-form :inline="true">
              <el-form-item>
                <el-input v-model="formData.iosUpdateUrl" style="width: 350px;" placeholder="苹果-更新URL" />
              </el-form-item>

              <el-form-item label="苹果-评论URL" prop="iosCommentUrl">
                <el-input v-model="formData.iosCommentUrl" style="width: 350px;" placeholder="苹果-评论URL" />
              </el-form-item>
            </el-form>

          </el-form-item>

          <el-form-item label="设备" prop="gu_device">
            <el-form :inline="true">
              <el-form-item>
                <el-select v-model="formData.device" placeholder="请选择">
                  <el-option
                    v-for="item in deviceType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>

              <el-form-item label="生效平台" prop="plat">
                <el-select v-model="formData.plat" placeholder="请选择">
                  <el-option
                    v-for="item in deviceType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>

              <el-form-item label="新版本" prop="newVersion">
                <el-input v-model="formData.newVersion" style="width: 350px;" placeholder="新版本" />
              </el-form-item>
            </el-form>
          </el-form-item>

          <el-form-item label="背景资源" prop="img">
            <el-form :inline="true">
              <el-form-item>
                <el-input v-model="formData.img" style="width: 350px;" placeholder="背景资源" />
              </el-form-item>

              <el-form-item label="主题" prop="topic">
                <el-input v-model="formData.topic" style="width: 350px;" placeholder="主题" />
              </el-form-item>

            </el-form>
          </el-form-item>

          <el-form-item label="语言" prop="langs">
            <el-select v-model="formData.langs" style="width: 1000px" multiple placeholder="请选择">
              <el-option
                v-for="(item, index) in lang"
                :key="index"
                :label="item"
                :value="index"
              />
            </el-select>
            <el-upload
              ref="upload"
              style="display: inline-block"
              class="upload-demo"
              :action="sys_app_logoAction"
              accept="xlsx"
              :limit="1"
              :on-success="(res)=>{return importUploadSuccess(res)}"
              :headers="headers"
            >
              <el-button style="margin-left: 10px" :loading="loading" icon="el-icon-upload2" type="primary">导入</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="版本" prop="version">
            <el-select v-model="formData.version" multiple placeholder="请选择" style="width: 800px">
              <el-option
                v-for="item in versionData"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item prop="title">
            <el-form :inline="true">
              <el-row v-for="(l, li) in formData.langs" :key="li">
                <el-form-item :label="lang[l]+': 标题'" style="margin-top: 8px;">
                  <el-input v-model="formData.title[l]" style="width: 480px;" :placeholder="lang[l]+': 标题'" />
                </el-form-item>
                <el-form-item label="内容" style="margin-top: 8px;">
                  <el-input
                    v-model="formData.body[l]"
                    placeholder="请输入内容"
                    style="width: 480px;"
                  />
                </el-form-item>
              </el-row>
            </el-form>
          </el-form-item>
          <el-form-item label="奖励" prop="rewards">
            <el-form :inline="true">
              <el-row v-for="(pp,pi) in formData.reward" :key="pi">
                <el-form-item label="道具" style="margin-top: 10px;">
                  <el-select v-model.number="pp.propsId" style="width: 130px;" placeholder="请选择">
                    <el-option
                      v-for="(item, index) in rewardType"
                      :key="index"
                      :disabled="!rewardId.includes(item.value)"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="奖品数量" style="margin-top: 10px;">
                  <el-input v-model.number="pp.num" style="width: 130px;" placeholder="奖品数量" />
                </el-form-item>
                <el-form-item style="margin-top: 10px;" label="金币取值">
                  <el-select v-model.number="pp.rtype" :disabled="pp.propsId !== 14" placeholder="请选择" style="width: 120px">
                    <el-option
                      v-for="item in selectType"
                      :key="item.id"
                      :label="item.title"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item style="margin-top: 10px;">
                  <el-button type="danger" @click="removeReward(pi)">删除</el-button>
                </el-form-item>
              </el-row>
              <el-form-item style="margin-top: 10px">
                <el-button type="primary" @click="addReward()">+</el-button>
              </el-form-item>
            </el-form>
          </el-form-item>
          <!--          <el-form-item label="时间描述" prop="time_desc">-->
          <!--            <el-form :inline="true">-->
          <!--              <el-row v-for="(v,k) in formData.time_desc" :key="k">-->
          <!--                <el-form-item label="Key" style="margin-top: 10px;">-->
          <!--                  <el-input v-model="v.key" style="width: 130px;" placeholder="KEY" />-->
          <!--                </el-form-item>-->
          <!--                <el-form-item label="Value" style="margin-top: 10px;">-->
          <!--                  <el-input v-model="v.value" style="width: 130px;" placeholder="Value" />-->
          <!--                </el-form-item>-->
          <!--                <el-form-item style="margin-top: 10px;">-->
          <!--                  <el-button type="danger" @click="removeReward(k,2)">删除</el-button>-->
          <!--                </el-form-item>-->
          <!--              </el-row>-->
          <!--              <el-form-item style="margin-top: 10px">-->
          <!--                <el-button type="primary" @click="addReward(2)">+</el-button>-->
          <!--              </el-form-item>-->
          <!--            </el-form>-->
          <!--          </el-form-item>-->
          <!--          <el-form-item label="范围描述" prop="range_desc">-->
          <!--            <el-form :inline="true">-->
          <!--              <el-row v-for="(v,k) in formData.range_desc" :key="k">-->
          <!--                <el-form-item label="Key" style="margin-top: 10px;">-->
          <!--                  <el-input v-model="v.key" style="width: 130px;" placeholder="KEY" />-->
          <!--                </el-form-item>-->
          <!--                <el-form-item label="Value" style="margin-top: 10px;">-->
          <!--                  <el-input v-model="v.value" style="width: 130px;" placeholder="Value" />-->
          <!--                </el-form-item>-->
          <!--                <el-form-item style="margin-top: 10px;">-->
          <!--                  <el-button type="danger" @click="removeReward(k,3)">删除</el-button>-->
          <!--                </el-form-item>-->
          <!--              </el-row>-->
          <!--              <el-form-item style="margin-top: 10px">-->
          <!--                <el-button type="primary" @click="addReward(3)">+</el-button>-->
          <!--              </el-form-item>-->
          <!--            </el-form>-->
          <!--          </el-form-item>-->
          <el-form-item>
            <el-button type="primary" @click="onSubmit">保存</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getRewardType } from '@/api/config/slot'
import { searchUid } from '@/api/user/user_info'
import { getToken } from '@/utils/auth'
import { importGameUpdateLang } from '@/api/config/game-update-cfg'
import { getAnnouncement2List, updateAnnouncement2Cfg } from '@/api/config/announcement-cfg2'
import { getVersionCfg } from '@/api/config/version-set'

export default {
  name: 'Announcement2Edit',
  data() {
    return {
      rewardId: [14, 15],
      versionData: [],
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      rewardType: [],
      total: 0,
      statusType: [
        { label: '是', value: 1 },
        { label: '否', value: 0 }
      ],
      deviceType: [
        { label: '全部', value: 0 },
        { label: '安卓', value: 1 },
        { label: '苹果', value: 2 }
      ],
      selectType: [
        {
          'id': 1,
          'title': '只取数量'
        },
        {
          'id': 2,
          'title': '等级取值'
        }
      ],
      users: [],
      lang: {
        'en': '英 文',
        'zh': '中 文',
        'tw': '繁 体',
        'fr': '法 语',
        'de': '德 语',
        'es': '西班牙',
        'pt': '葡萄牙',
        'th': '泰 语',
        'vn': '越 南',
        'no': '挪 威',
        'id': '印 尼',
        'my': '马来西亚',
        'ro': '罗马尼亚'
      },
      loading: false,
      formData:
        {
          'id': 0,
          'title': {},
          'body': {},
          'stime': '',
          'etime': '',
          'device': 0,
          'fansUrl': '',
          'updateUrl': '',
          'commentUrl': '',
          'iosUpdateUrl': '',
          'iosCommentUrl': '',
          'version': [],
          'time_desc': [],
          'range_desc': [],
          'topic': '',
          'newVersion': 0,
          'is_force': 0,
          'img': '',
          'plat': 0,
          'langs': [],
          'reward': [{
            propsId: 14,
            skin: 0,
            num: 10,
            rtype: 2
          }]
        },
      rules: {}
    }
  },
  created() {
    this.getVersion()
    const id = this.$route.query.id
    console.log(id)
    if (id > 0) {
      this.getTables(id)
    }
    this.getRewardTypeData()
  },
  methods: {
    getVersion() {
      getVersionCfg().then(res => {
        if (res.code === 200) {
          res.data.forEach(item => {
            this.versionData.push({ label: item, value: item })
          })
        } else {
          this.msgError(res.msg)
        }
      })
    },
    importUploadSuccess(response) {
      this.loading = true
      this.$refs.upload.clearFiles()
      importGameUpdateLang({ data: response.data.path }).then(res => {
        this.loading = false
        // eslint-disable-next-line eqeqeq
        if (res.code === 200) {
          this.formData.langs = res.data.lang
          this.formData.title = res.data.title
          this.formData.body = res.data.body
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables(id) {
      getAnnouncement2List({ id: id }).then(res => {
        if (res.code === 200) {
          const data = res.data.list[0]
          this.$set(data, 'langs', [])
          this.$set(data, 'body', {})
          for (const i in data.content) {
            const val = data.content[i]
            data.body[i] = val
            data.langs.push(i)
          }
          const timeDesc = []
          for (const i in data.time_desc) {
            const val = data.time_desc[i]
            timeDesc.push({ key: i, value: val })
          }

          const rangeDesc = []
          for (const i in data.range_desc) {
            const val = data.range_desc[i]
            rangeDesc.push({ key: i, value: val })
          }
          data.time_desc = timeDesc
          data.range_desc = rangeDesc
          this.formData = data
          console.log('this.formData', this.formData)
        } else {
          this.msgError(res.msg)
        }
      })
    }, onSubmit() {
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          // if (!this.formData.stime) {
          //   this.msgError('请输入开始时间')
          //   return
          // }
          // if (!this.formData.etime) {
          //   this.msgError('请输入结束时间')
          //   return
          // }
          // if (this.formData.stime > this.formData.etime) {
          //   this.msgError('开始时间不能大于结束时间')
          //   return
          // }

          if (!this.formData.fansUrl) {
            this.msgError('粉丝URL式有误')
            return
          }

          if (!this.formData.commentUrl) {
            this.msgError('安卓评论URL式有误')
            return
          }

          if (!this.formData.updateUrl) {
            this.msgError('安卓更新URL式有误')
            return
          }

          if (!this.formData.iosCommentUrl) {
            this.msgError('苹果评论URL式有误')
            return
          }

          if (!this.formData.iosUpdateUrl) {
            this.msgError('苹果更新URL式有误')
            return
          }

          const regex = /^(\d+\.)+\d+$/

          if (!regex.test(this.formData.newVersion)) {
            this.msgError('版本格式有误')
            return
          }
          if (this.formData.langs.length > 0) {
            for (const i in this.formData.langs) {
              const _lang = this.formData.langs[i]
              const _title = this.formData.title[_lang]
              if (_title === '' || _title === undefined) {
                this.msgError('标题 ' + this.lang[_lang] + ' 不能为空')
                return
              }
            }

            for (const i in this.formData.langs) {
              const _lang = this.formData.langs[i]
              const _content = this.formData.body[_lang]
              if (_content === '' || _content === undefined) {
                this.msgError('内容 ' + this.lang[_lang] + ' 不能为空')
                return
              }
            }
          }

          // if (this.formData.time_desc.length > 0) {
          //   for (const i in this.formData.time_desc) {
          //     const val = this.formData.time_desc[i]
          //     if (!val.key) {
          //       this.msgError('时间描述key不能为空')
          //       return
          //     }
          //
          //     if (!val.value) {
          //       this.msgError('时间描述value不能为空')
          //       return
          //     }
          //   }
          // }

          // if (this.formData.range_desc.length > 0) {
          //   for (const i in this.formData.range_desc) {
          //     const val = this.formData.range_desc[i]
          //     if (!val.key) {
          //       this.msgError('范围描述key不能为空')
          //       return
          //     }
          //
          //     if (!val.value) {
          //       this.msgError('范围描述value不能为空')
          //       return
          //     }
          //   }
          // }

          const newObj = Object.assign({}, this.formData)
          newObj.content = this.formData.body
          const timeDesc = {}
          for (const i in newObj.time_desc) {
            const val = newObj.time_desc[i]
            timeDesc[val.key] = val.value
          }
          const rangeDesc = {}
          for (const i in newObj.range_desc) {
            const val = newObj.range_desc[i]
            rangeDesc[val.key] = val.value
          }
          newObj.time_desc = timeDesc
          newObj.range_desc = rangeDesc
          const data = JSON.stringify(newObj)
          console.log('daat', data)
          updateAnnouncement2Cfg({ data: data }).then(res => {
            if (res.code === 200) {
              this.msgSuccess(res.msg)
              this.$router.push({ path: '/config/announcement2/index' })
            } else {
              this.msgError(res.msg)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true
        searchUid({ id: query }).then(res => {
          this.loading = false
          this.users = res.data
        })
      } else {
        this.users = []
      }
    },
    getRewardTypeData() {
      getRewardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.rewardType.push({ 'label': res.data[i], 'value': parseInt(i) })
          }
        }
      })
    },
    addReward(typ = 1) {
      switch (typ) {
        case 1:
          this.formData.reward.push({
            propsId: 14,
            skin: 0,
            num: 1,
            rtype: 2
          })
          break

        case 2:
          this.formData.time_desc.push({
            key: '',
            value: ''
          })
          break

        case 3:
          this.formData.range_desc.push({
            key: '',
            value: ''
          })
          break
      }
    },
    removeReward(i, typ = 1) {
      switch (typ) {
        case 1:
          this.formData.reward = this.formData.reward.filter((item, key) => {
            return i !== key
          })
          break

        case 2:
          this.formData.time_desc = this.formData.time_desc.filter((item, key) => {
            return i !== key
          })
          break

        case 3:
          this.formData.range_desc = this.formData.range_desc.filter((item, key) => {
            return i !== key
          })
          break
      }
    }
  }
}
</script>

<style scoped>
</style>
